/**
 *
 * @param {number} to - pixels from the top of the scrolling element
 * @param {number} duration - scroll time in milliseconds
 * @param [scrollElement=document.documentElement] - element to scroll
 * @description Animates vertical scrolling
 */
export const scrollTop = (to, duration, scrollElement) => {
  if (!scrollElement) {
    scrollElement = document.documentElement;
  }
  const start = scrollElement.scrollTop;
  const change = to - start;
  let currentTime = 0,
    increment = 20;

  const animateScroll = () => {
    currentTime += increment;
    scrollElement.scrollTop = Math.easeInOutQuad(
      currentTime,
      start,
      change,
      duration
    );
    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    }
  };
  animateScroll();
};

/**
 *
 * @param {number} to - pixels from the left of the scrolling element
 * @param {number} duration - scroll time in milliseconds
 * @param [scrollElement=document.documentElement] - element to scroll
 * @description Animates horizontal scrolling
 */
export const scrollLeft = (to, duration, scrollElement) => {
  if (!scrollElement) {
    scrollElement = document.documentElement;
  }
  const start = scrollElement.scrollLeft;
  const change = to - start;
  let currentTime = 0,
    increment = 20;

  const animateScroll = () => {
    currentTime += increment;
    const val = Math.easeInOutQuad(currentTime, start, change, duration);
    scrollElement.scrollLeft = val;
    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    }
  };
  animateScroll();
};

/**
 *
 * @param targetElement - element to scroll to
 * @param {number} duration - scroll time in milliseconds
 * @param [scrollElement=document.documentElement] - element to scroll
 * @description Scrolls to the top of the targeted element
 */
export const scrollToElement = (targetElement, duration, scrollElement) => {
  elementOffset(targetElement).then(offset => {
    scrollTop(offset.top, duration, scrollElement);
  });
};

/**
 *
 * @param element - element to find offset relative to the document
 * @returns {Promise<Object>} - promise that returns an object containing the top and left offsets of the element
 * @description Calculates the offset of an element relative to the document (not viewport)
 */
export const elementOffset = element => {
  return new Promise((resolve, reject) => {
    setTimeout(function() {
      let rect = element.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      resolve({ top: rect.top + scrollTop, left: rect.left + scrollLeft });
    }, 300);
  });
};

//t = current time
//b = start value
//c = change in value
//d = duration
Math.easeInOutQuad = function(t, b, c, d) {
  t /= d / 2;
  if (t < 1) return (c / 2) * t * t + b;
  t--;
  return (-c / 2) * (t * (t - 2) - 1) + b;
};
